import { css } from "@linaria/core";

export const legalPage = css`
  min-height: 100vh;
  background: var(--ant-color-bg-layout);
  display: flex;
  flex-direction: column;
`;

export const logoHomeLink = css`
  display: inline-flex;
  align-items: center;
  gap: var(--ant-margin-xs);
  text-decoration: none;
  color: inherit;
`;

export const legalContent = css`
  flex: 1;
  max-width: 800px;
  width: 100%;
  margin: 0 auto;
  padding: var(--ant-padding-xl) var(--ant-padding-lg);
  background: var(--ant-color-bg-container);

  @media (max-width: 576px) {
    padding: var(--ant-padding-lg) var(--ant-padding);
  }
`;

export const legalTitle = css`
  margin-top: 0;
  margin-bottom: var(--ant-margin-xs);
`;

export const lastUpdated = css`
  display: block;
  margin-bottom: var(--ant-margin-lg);
  color: var(--ant-color-text-secondary);
  font-size: var(--ant-font-size-sm);
`;

export const intro = css`
  margin-bottom: var(--ant-margin-lg);
`;

export const sectionHeading = css`
  margin-top: var(--ant-margin-xl);
  margin-bottom: var(--ant-margin-sm);
`;

export const sectionBody = css`
  margin-bottom: var(--ant-margin);
  line-height: var(--ant-line-height-lg);

  & ul {
    margin: var(--ant-margin-xs) 0 var(--ant-margin) var(--ant-margin);
    padding: 0;
  }

  & li {
    margin-bottom: var(--ant-margin-xxs);
  }
`;

export const companyBlock = css`
  margin-top: var(--ant-margin-xl);
  padding-top: var(--ant-padding);
  border-top: var(--ant-line-width) solid var(--ant-color-border-secondary);
  color: var(--ant-color-text-secondary);
  font-style: italic;
`;

export const footerLine = css`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
  gap: var(--ant-margin-xs);

  & a {
    color: var(--ant-color-text-secondary);
    text-decoration: none;

    &:hover {
      color: var(--ant-color-link);
    }
  }
`;

export const footerSeparator = css`
  color: var(--ant-color-text-quaternary);
`;
